// removed by extract-text-webpack-plugin
module.exports = {"swirl":"_39vnBHMWLsi7pPa0DeCN2- position-absolute fontSize-xxs textAlign-left transitionDuration-m textTransform-uppercase","badge":"_219-q9e5tuGLd0ofxt17RK borderStyle-solid borderWidth-1 display-inlineBlock fontSize-xs fontWeight-5 textAlign-center whiteSpace-nowrap textTransform-uppercase","badgeGreen":"_2zNUqrJ6DY72K1P6scdnYk bg-green borderColor-green c-white","badgeTransparent":"_3oOz-m7NNwWuSmoZTWybs9 bg-transparent borderColor-green c-green"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Pricing/BillingSwitch/BillingSwitch.css
// module id = 764
// module chunks = 18116671869107 156544657062075